export const BLOGS_PAGE_LOADER = "BLOGS_PAGE_LOADER";
export const BLOGS_PAGE_SUCCESS = "BLOGS_PAGE_SUCCESS";
export const BLOGS_PAGE_FAILURE = "BLOGS_PAGE_FAILURE";
export const BLOGS_PAGE_RESET = "BLOGS_PAGE_RESET";